import { createEntityAdapter } from '@reduxjs/toolkit';
import { IValveConnectorGrid } from 'application/components/api/ValveConnectorGrid';

export const valveConnectorGridAdapter = createEntityAdapter<IValveConnectorGrid, number>({
  selectId: (project) => project.valveConnectorGridID,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});
